// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.accounting.billing.BillingServiceResponse */
/* istanbul ignore next */
@GandalfModel
export class BillingServiceResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	code!: string | null;

	@GandalfProperty({ designType: String })
	description!: string | null;

	@GandalfProperty({ designType: Number })
	encounterId!: number | null;

	@GandalfProperty({ designType: Number })
	invoiceId!: number | null;

	@GandalfConstantDecorator(constants.BillingInvoiceStatus)
	@GandalfProperty({ designType: constants.BillingInvoiceStatus })
	invoiceStatus!: constants.BillingInvoiceStatus | null;

	@GandalfProperty({ designType: Boolean })
	nonBillable!: boolean | null;

	@GandalfProperty({ designType: Number })
	performedServiceId!: number | null;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	retailPrice!: number | null;

}
